import React from 'react';
import type { Extension } from '../../web-client';
import { ForgeDevSpaceErrorMessage, isDeveloperSpaceError } from './ForgeDevSpaceErrorMessage';
import { ForgeDeprecationMessage, SANDBOX_DEPRECATION_ERROR } from './ForgeDeprecationMessage';

interface ForgeAppErrorMessageProps {
	error: string;
	extension: Extension;
}

export const shouldRenderForgeAppErrorMessage = (error: string): boolean => {
	return isDeveloperSpaceError(error) || error === SANDBOX_DEPRECATION_ERROR;
};

export const ForgeAppErrorMessage = (props: ForgeAppErrorMessageProps): React.JSX.Element => {
	const { error, extension } = props;

	if (isDeveloperSpaceError(error ?? '')) {
		return <ForgeDevSpaceErrorMessage />;
	}

	return <ForgeDeprecationMessage error={error ?? ''} extension={extension} />;
};
